<template>
  <div
    v-if="isHave"
    class="content flex flex-direction align-center justify-center"
  >
    <div class="noimg">
      <img
        src="../../../assets/images/parallelSessions/list/nodata-wap.png"
        alt=""
      />
    </div>
    <div class="text">暂无相关数据</div>
  </div>
</template>

<script>
export default {
  name: "noData",
  props: {
    isHave: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 992px) {
}
@media screen and (max-width: 992px) {
  .content {
    width: 100%;
    height: 100%;
    .noimg {
      width: 212px;
      height: 215px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .text {
      margin-top: 42px;
      height: 36px;
      font-size: 24px;
      font-family: FZLanTingHeiS-R-GB-Regular, FZLanTingHeiS-R-GB;
      font-weight: 400;
      color: #151e26;
    }
  }
}
</style>
